module.exports = {
	// HTTP_REQUEST_URL: 'https://bigdata.hsxsn.cn',
	HTTP_REQUEST_URL: 'https://bigdata.vend7.com',
	// COMMON_TITLE: '皇氏学生奶数据平台'
	COMMON_TITLE: '华售信息大数据平台'
}